<template>
  <div class="homeBox" style="padding: 20px 50px" v-loading="loading">
    <div class="console">
      <div style="margin: 20px 30px;float: left" v-show="!loading">
        <div style="float: left;margin: 30px" v-if="dashboardSales != 0">
          <modular title="销售明细" subtitle="已发放红利部分" path="/ReportDetailPage" :svg-url="svg1" message=""
                   :disabled="dashboardSales == 0"/>
        </div>
        <div style="float: left;margin: 30px" v-if="dashboardSales != 0">
          <modular title="申报明细" subtitle="未发放红利部分（未结算、待审核、已退回）" path="/ReportDetailUnsettle"
                   :svg-url="svg2" message="" :disabled="dashboardSales == 0"/>
        </div>
        <!--        <div style="float: left;margin: 30px" v-if="dashboardSales == 1">-->
        <!--          <modular title="数据分析" subtitle="业务数据多维度可视化分析" @toPath="toDataAnalysis" :svg-url="svg3" message="现正免费开放试用中" :disabled="dashboardSales != 1" />-->
        <!--        </div>-->
        <div style="float: left;margin: 30px" v-if="dashboardSales != 0">
          <modular title="导购员名单" subtitle="下载导购员名单及门店信息" path="/ReportDetailPagePurchase"
                   :svg-url="svg4" :message="salesMsg" :disabled="dashboardSales == 0"/>
        </div>
        <div style="float: left;margin: 30px" v-if="dashboardSales == 1">
          <modular title="冻结名单管理" subtitle="批量处理导购申报权限冻结名单,查看全网通报导购" path="/BlockedInfoView"
                   :svg-url="svg18" :disabled="dashboardSales != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="dashboardSales == 1">
          <modular title="自定义标签" subtitle="为导购添加自定义标签（如：门店编码）" path="/LabelView" :svg-url="svg5"
                   message="" :disabled="dashboardSales != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="dashboardSales == 1">
          <modular title="导购业务员对接" subtitle="调整导购与业务员对接状态" path="/ManagerView" :svg-url="svg6"
                   message="" :disabled="dashboardSales != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="dashboardSales == 1">
          <modular title="业务员权限配置" subtitle="调整业务员权限" path="/SupplierInfo" :svg-url="svg7" message=""
                   :disabled="dashboardSales != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="dashboardSales == 1">
          <modular title="在店打卡明细" subtitle="查看导购打卡明细" path="/SalePunchInfo" :svg-url="svg17"
                   :disabled="dashboardSales != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="基础账户明细" subtitle="渠道红利资金流水明细" path="/ChannelFlowDetails" :svg-url="svg8"
                   :message="channelMsg" :disabled="dashboardSales != 1 || isAdmin != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="resourceBundle && !(dashboardSales != 1 || isAdmin != 1)">
          <modular title="资源包管理" subtitle="预购资源包享费用优惠" path="/PackageExplorer" :svg-url="svg16"
                   :message="channelMsg" :disabled="dashboardSales != 1 || isAdmin != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="服务费账单" subtitle="查询平台服务费账单明细" path="/ServiceChargeView" :svg-url="svg9"
                   :message="serviceMsg" :disabled="dashboardSales != 1 || isAdmin != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="服务费账户明细" subtitle="查看服务费账户信息" path="/ServiceChargeWallet" :svg-url="svg10"
                   :message="serviceMsg" :disabled="dashboardSales != 1 || isAdmin != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="发票明细" subtitle="查询平台发票明细" path="/InvoiceInfoView" :svg-url="svg11"
                   :message="serviceMsg" :disabled="dashboardSales != 1 || isAdmin != 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1 || instruction)">
          <modular title="资金特发管理" subtitle="特发资金到指定人员账户" path="/Instruction" :svg-url="svg12"
                   message="" :disabled="dashboardSales != 1 || isAdmin != 1 || instruction"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="全局管理设置" subtitle="全局管理设置" path="/CoreAdmin" :svg-url="svg13" message=""
                   :disabled="dashboardSales != 1 || isAdmin != 1"/>
        </div>

        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="产品管理" subtitle="管理申报产品详情" path="/ProductManagement" :message="productMsg"
                   :messageColor="'#576B95'"
                   :svg-url="svg19" :disabled="false"/>
        </div>

        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || isAdmin != 1)">
          <modular title="提成规则管理" subtitle="新建、发布和管理提成规则" path="/Package" :message="packageMsg"
                   :messageColor="'#576B95'"
                   :svg-url="svg20" :disabled="false"/>
        </div>

        <div style="float: left;margin: 30px" v-if="!(stock < 1) && !isManagerLogin && dashboardSales != 0">
          <modular title="进销存管理" subtitle="渠道进销数据录入与库存管理" path="/PurchaseSaleStorage" :svg-url="svg15"
                   message="" :disabled="stock < 1"/>
        </div>
        <div style="float: left;margin: 30px" v-if="!(dashboardSales != 1 || package)">
          <modular title="提成规则审核" subtitle="提成规则审核" path="/RuleReview" :svg-url="svg14" message=""
                   :disabled="dashboardSales != 1 || package"/>
        </div>
      </div>
    </div>
    <div style="width: 76%;bottom: 10px;margin-left: 12%; overflow: hidden;">
      <el-carousel :interval="4000" :height="imgHeight" loop indicator-position="none">
        <el-carousel-item v-for="(item,index) in imgList" :key="index">
          <el-row :gutter="12">
            <a :href="item" target="_blank"><img ref="imgHeight" :src="item" @load="imgLoad" style="width: 100%"></a>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import propaganda1 from "@/assets/图片1.png"
import propaganda2 from "@/assets/图片2.png"
import propaganda3 from "@/assets/图片3.png"
import propaganda4 from "@/assets/图片4.png"
import propaganda5 from "@/assets/图片5.png"
import propaganda6 from "@/assets/图片6.png"
import propaganda7 from "@/assets/图片7.png"
import propaganda8 from "@/assets/图片8.png"
import propaganda9 from "@/assets/图片9.png"
import propaganda10 from "@/assets/图片10.png"
import propaganda11 from "@/assets/图片11.png"
import propaganda12 from "@/assets/图片12.png"
import propaganda13 from "@/assets/图片13.png"
import Modular from "@/components/homeModular/modular"
import svg1 from "@/assets/modularSvg/销售明细1.svg"
import svg2 from "@/assets/modularSvg/销售明细2.svg"
import svg3 from "@/assets/modularSvg/数据分析.svg"
import svg4 from "@/assets/modularSvg/导购员名单.svg"
import svg5 from "@/assets/modularSvg/自定义标签.svg"
import svg6 from "@/assets/modularSvg/对接业务员.svg"
import svg7 from "@/assets/modularSvg/业务员设置.svg"
import svg8 from "@/assets/modularSvg/资金特发管理.svg"
import svg9 from "@/assets/modularSvg/服务费账单.svg"
import svg10 from "@/assets/modularSvg/账户资金.svg"
import svg11 from "@/assets/modularSvg/发票明细.png"
import svg12 from "@/assets/modularSvg/资金特发管理.svg"
import svg13 from "@/assets/modularSvg/全局管理设置.png"
import svg14 from "@/assets/modularSvg/提成规则审核.png"
import svg15 from "@/assets/modularSvg/进销存管理.svg"
import svg16 from "@/assets/modularSvg/资源包管理.png"
import svg17 from "@/assets/modularSvg/salePunch.png"
import svg18 from "@/assets/modularSvg/冻结名单管理.png"
import svg19 from "@/assets/modularSvg/产品管理.png"
import svg20 from "@/assets/modularSvg/提成规则管理.png"
import {toDataAnalysis} from "@/api/dataAnalysis"
import AES from "@/api/AES"
import {consoleInit} from "@/api/login"
import {MessageBox} from "element-ui";
import {getManager} from '@/api/ReportDetailPage'

export default {
  name: "Home",
  components: {Modular},
  data() {
    return {
      dis: true,
      colordis: '',
      searchs: '',
      supid: '',
      token: '',
      instruction: true,
      ChannelFlowDetail4: false,
      colorChannelFlowDetails: '',
      carouselKey: 0,
      stock: undefined,
      imgHeight: '',
      imgList: [
        propaganda1,
        propaganda2,
        propaganda3,
        propaganda4,
        propaganda5,
        propaganda6,
        propaganda7,
        propaganda8,
        propaganda9,
        propaganda10,
        propaganda11,
        propaganda12,
        propaganda13,
      ],
      loading: false,
      modular: [],
      svg1: svg1,
      svg2: svg2,
      svg3: svg3,
      svg4: svg4,
      svg5: svg5,
      svg6: svg6,
      svg7: svg7,
      svg8: svg8,
      svg9: svg9,
      svg10: svg10,
      svg11: svg11,
      svg12: svg12,
      svg13: svg13,
      svg14: svg14,
      svg15: svg15,
      svg16: svg16,
      svg17: svg17,
      svg18: svg18,
      svg19: svg19,
      svg20: svg20,
      sale3: false,
      serviceCharge5: false,
      label6: false,
      instruction8: false,
      storage9: false,
      salesman10: false,
      channelMsg: '',
      salesMsg: '',
      serviceMsg: '',
      productMsg: '',
      packageMsg: '',
      managers: '',
      package: false,
      dashboardSales: '',
      isAdmin: '',
      isManagerLogin: false,
      resourceBundle: false
    }
  },
  created() {
    let stock = localStorage.getItem('stock')
    let bonus_order = localStorage.getItem('bonus_order')
    this.dashboardSales = localStorage.getItem('dashboardSales') //0.无权限 1.按数据中心账号汇总 2.按绑定业务员汇总
    this.isAdmin = localStorage.getItem('isAdmin') //0不是 1是
    this.isManagerLogin = localStorage.getItem('managerId') != 'null'
    this.resourceBundle = eval(localStorage.getItem('resourceBundle').toLowerCase());

    // 判断是否有进入特发的权限
    this.instruction = !(bonus_order == 1)
    // 判断是否有权限进去进销存
    let storage = stock < 1
    this.stock = stock
    // 判断是否有权限进去业务员名单
    this.getManagers()

    let token = localStorage.getItem('token')
    let salesMsg = undefined
    let channelMsg = undefined
    let serviceMsg = undefined
    let productMsg = undefined
    let packageMsg = undefined

    this.loading = true
    consoleInit(token).then(({data}) => {
      let {date} = data
      let {sales, channel, service, M1, product, packages} = date
      salesMsg = sales
      channelMsg = channel
      serviceMsg = service
      productMsg = product;
      packageMsg = packages;
      this.channelMsg = channelMsg
      this.salesMsg = salesMsg
      this.serviceMsg = serviceMsg
      this.productMsg = productMsg;
      this.packageMsg = packageMsg;

      this.instruction8 = this.instruction
      this.storage9 = storage
      this.package = date.package === '0' ? true : false

      if (M1 === false) {
        MessageBox.confirm('当前待确认服务费' + M1 + '元，前往确认？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false
        }).then(() => {
          this.$router.replace({path: '/ServiceChargeView'})
        })
      }
    }).finally(() => this.loading = false)

    window.onresize = () => {
      this.imgLoad()
    }
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.imgHeight['0'].height + 'px'
      })
    },
    toDataAnalysis() {
      toDataAnalysis()
    },
    getManagers() {
      this.token = localStorage.getItem('token')
      getManager(this.token).then(res => {
        if (res.data.date.manager === 0) {
          this.salesman10 = true
        }
      })
    },
  }
}
</script>

<style scoped>
.homeBox {
  width: 92%;
  height: 92%;
  top: 0px;
  background-color: #fafafa;
}

.console {
  font-size: 30px;
  text-align: center;
}
</style>
